var router = require('pjax').Router;
var index = require('./index.js');
var decide = require('./decide.js');
var slideshow = require('./slideshow.js');

router.get('qualify/([a-zA-Z]+)/([a-zA-Z]+)', decide);
router.get('qualify/([a-zA-Z]+)/([a-zA-Z]+)/slideshow', slideshow);
router.get('qualify', index);
